module.exports = __webpack_public_path__ + "img/JF-SFZ.716b6753.png";